import { ReactNode } from 'react';
import Button from '@/components/Button';
import { ProductListListPath } from '@/modules/product/paths';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

interface ProductListUnavailableStateProps {
  message?: string;
  action?: ReactNode;
}

const ProductListUnavailableState = ({
  message = 'This Product List is unavailable or you no longer have access to it.',
  action,
}: ProductListUnavailableStateProps) => (
  <div className="flex flex-col items-center justify-center gap-4 py-20 text-center">
    <h2 className="text-lg font-semibold text-gray-900">Product List not found</h2>
    <p className="max-w-md text-sm text-gray-600">{message}</p>
    {action ?? (
      <Button
        to={ProductListListPath}
        variant="secondary"
        icon={<ArrowLeftIcon className="h-5 w-5 mr-1" aria-hidden="true" />}
      >
        Back to Product Lists
      </Button>
    )}
  </div>
);

export default ProductListUnavailableState;
